module.exports = __webpack_public_path__ + "img/news-story-detail-hero.png?45d067c02f1da86a0851b9069ded6e7e";